export const CATEGORY_DEFINITIONS = {
  hair_density: {
    title: 'Hair Density',
    what: 'How much of your scalp is covered by visible hair in the photo.',
  },
  scalp_exposure: {
    title: 'Scalp Visibility',
    what: 'How much bare scalp shows through between hairs.',
  },
  hair_gap: {
    title: 'Space Between Hairs',
    what: 'The average open gap on your scalp where hair is missing or thin.',
  },
  hair_thickness: {
    title: 'Hair Thickness',
    what: 'How thick individual hair strands look in the magnified image.',
  },
  follicle_spacing: {
    title: 'Distance Between Follicles',
    what: 'How far apart the hair roots (follicles) are from each other.',
  },
  depth_hair: {
    title: 'Hair Depth',
    what: 'How deep or raised the hair appears compared to the scalp surface.',
  },
  depth_scalp: {
    title: 'Scalp Depth',
    what: 'The surface depth of visible scalp areas in the image.',
  },
};

export const LEVEL_MEANINGS = {
  Sparse: 'Hair coverage looks thin — more scalp may be visible than ideal.',
  Moderate: 'Hair coverage is in a typical middle range.',
  Dense: 'Good hair coverage — most of the scalp area is filled in.',
  'Very Dense': 'Very full hair coverage across the analyzed area.',
  Low: 'Little bare scalp is showing — a healthy sign for coverage.',
  High: 'A lot of scalp is visible — hair may look thinner in this area.',
  Narrow: 'Gaps between hairs are small — hair sits close together.',
  Wide: 'Gaps between hairs are large — patches may look sparse.',
  'Very Fine': 'Strands appear very thin.',
  Fine: 'Strands are on the finer side.',
  Thick: 'Strands look thicker than average.',
  'Very Thick': 'Strands are notably thick.',
  Close: 'Follicles are packed closely together.',
  Shallow: 'Surface appears relatively flat in this region.',
  Deep: 'Surface shows more depth variation.',
};

export const OVERLAY_DESCRIPTIONS = {
  annotated_summary_url: 'A labeled map of your image. Green = hair, red = centerlines, yellow = follicles, blue = scalp gaps. Counts are in the legend.',
  original_url: 'Your uploaded magnified scalp photo, unchanged.',
  hair_mask_url: 'Green areas show where hair was detected in the image.',
  skeleton_url: 'Red lines trace the center of each detected hair strand.',
  contours_url: 'Green outlines mark the edges of each hair region.',
  density_heatmap_url: 'Warmer colors mean more hair in that area; cooler colors mean less.',
  depth_map_url: 'Brightness shows surface depth — useful for seeing scalp texture.',
};

export function levelMeaning(level) {
  return LEVEL_MEANINGS[level] || 'This measurement falls in a typical range for magnified scalp images.';
}
